<template>
  <EditBox :name="name" :styleList="styleList" :currentStyle.sync="localStyle" :tip="'间距设置'">
    <ItemSetting label="上下间距">
      <el-input type="number" placeholder="请输入上下间距" v-model.number="height"></el-input>
    </ItemSetting>
  </EditBox>
</template>

<script>
import EditBox from "./box/EditBox";
import ItemSetting from "./setting/ItemSetting";
import editMixin from './mixins/editMixin';

export default {
  name: 'SpacingEdit',
  mixins: [editMixin],
  components: {
    EditBox,
    ItemSetting
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    styleList: {
      type: Array,
      default: () => []
    },
    currentStyle: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    height: {
      get() {
        return this.value.height
      },
      set(val) {
        if (!val) {
          val = 10
        }
        if (val < 0) {
          this.$message.error('上下间距必须大于等于0')
          return
        }
        this.updateValue({ height: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
